'use strict';
/**
 * @author Maxim Seredkin
 */

export default function () {
  return {
    restrict: 'A',
    template: require('../view/plan-table-row.html'),
    transclude: true,
    scope: {
      item: '=?item',
    },
  };
}
